<template>
  <a-upload
      :action="action"
      :multiple="multiple"
      :accept="accept"
      name="media"
      :showUploadList="showUploadList"
      :data="data"
      :file-list="fileList"
      :before-upload="beforeUpload"
      @change="change"
      :remove="remove"
      ref="upload">
    <slot :fileList="showUploadList ? fileList:[]">
      <a-button>
        <a-icon type="upload" /> {{text}}
      </a-button>
    </slot>
  </a-upload>
</template>

<script>
export default {
  name: 'dol-upload',
  props: {
    text: {type: String, default(){
        return this.$t('uploadFiles')
      }},
    type: {type: String, default: ''},
    url: {type: String, default: '/system/tool/file/save'},
    multiple: {type: Boolean, default: false},            //是否多选
    serverType: {type: String},
    paramsData: {type: Object},
    showUploadList: {type: Boolean, default: true},            //列表显示方式
    data: {type: Object, default: () => {return {}}},            //回调
    uploadWithPick: {type: Boolean, default: true},            //回调
    accept: {type: String, default: '*'},            //允许上传类型
    value: {type: null},
    placeholder: {type: String, default: '上传图片'},
    maxSize: {type: Number, default: 1000},            //最大上传限制，单位K
  },
  data(){
    return {
      fileList:[],
    }
  },
  computed:{
    action() {
      const token = this.$store.state.userInfo && this.$store.state.userInfo.USER_ID || '10000001';
      let commonParams = {
        "SERVICE_TYPE": this.serverType,
        "USER_ID": token,
        "H5_CREATE_DATE": this.$moment().format('YYYY-MM-DD HH:mm:ss'),
        "INPUT_PARAM":[this.paramsData],
      }
      let action = '/container-erp/UploadFileAPI';
      action += `?postData=${JSON.stringify(commonParams)}`
      return action;
    },
  },
  methods: {
    beforeUpload(file, fileList) {
      if(this.multiple){
        this.fileList.push(file)
      }else {
        this.fileList = [file];
      }
      if(this.uploadWithPick){
        return true;
      }else{
        return false;
      }
    },
    change(info){
      if (info.file.status === 'uploading') {
        this.$emit('uploading', {percent: info.file.percent, size: info.file.size});
        this.$store.commit('setLoading', true);
        return
      }
      if (info.file.status === 'done') {
        let result = info.file.response;
        if (this.serverType === 'NodeJs') {
          if (result.success) {
            this.$message.info(this.$t('uploadSuccessful'));
            this.$emit('finished', result?.data);
          }
        } else {
          this.$message.info(this.$t('uploadSuccessful'));
          this.$emit('finished', result?.data);
        }
        this.emitValue(this.fileList);
        this.$store.commit('setLoading', false);
      }
    },
    emitValue(val){
      let fileList = [];
      if(this.multiple){
        val.forEach(item =>{
          if(item?.response){
            fileList.push({
              GUID_CODE: item?.response?.data?.FILE_LIST?.[0].GUID_CODE,
              FILE_NAME: item?.response?.data?.FILE_LIST?.[0].FILE_NAME,
            });
          }else {
            fileList.push({
              GUID_CODE: item?.uid,
              FILE_NAME: item?.name,
            });
          }
        })
      }else {
        if(val?.[0]?.response){
          fileList.push({
            GUID_CODE: val?.[0]?.response?.data?.FILE_LIST?.[0].GUID_CODE,
            FILE_NAME: val?.[0]?.response?.data?.FILE_LIST?.[0].FILE_NAME,
          });
        }else {
          fileList.push({
            GUID_CODE: val?.uid,
            FILE_NAME: val?.name,
          });
        }
      }
      this.$emit('input', fileList)
    },
    upload(){
      let param = new FormData();

      //通过append向form对象添加数据
      for(let key in this.data){
        param.append(key, this.data[key]);
      }

      //添加文件
      param.append("media", this.fileList[0]);

      //设置请求参数
      let config = {
        //添加请求头
        headers: { "Content-Type": "multipart/form-data" },
      };

      this.$ajax({
        url: this.url,
        data: param,
        headers: { "Content-Type": "multipart/form-data", token: this.$store.state.token },
        method: 'post',
        loading: true,
      }).then(result => {
        // this.$message.info(result.message);
        this.$emit('finished', this.fileList, result);
      })
    },
    //数据初始化
    updateData(val) {
      let fileList = [];
      if(this.multiple){
        val && val.forEach(item =>{
          if(item?.response){
            fileList.push({
              name: item?.response?.data?.FILE_LIST?.[0].FILE_NAME,
              uid: item?.response?.data?.FILE_LIST?.[0].uid || item?.response?.data?.FILE_LIST?.[0].GUID_CODE,
              fileId: item?.response?.data?.FILE_LIST?.[0].fileId || item?.response?.data?.FILE_LIST?.[0].GUID_CODE,
              status: item?.response?.data?.FILE_LIST?.[0].status || 'done',
              url: this.$Dolphin.path.filePath + item?.response?.data?.FILE_LIST?.[0].FILE_NAME,
            });
          }else {
            fileList.push({
              name: item.name || item.FILE_NAME,
              uid: item.uid || item.GUID_CODE,
              fileId: item.fileId || item.GUID_CODE,
              status: item.status || 'done',
              url: this.$Dolphin.path.filePath + item.FILE_NAME,
            });
          }
        })
      }else {
        if(val?.GUID_CODE || val?.[0]?.GUID_CODE){
          fileList.push({
            name: val?.FILE_NAME || val?.[0]?.FILE_NAME,
            uid: val?.GUID_CODE || val?.[0]?.uid || val?.[0]?.GUID_CODE,
            fileId: val?.GUID_CODE || val?.[0]?.fileId || val?.[0]?.GUID_CODE,
            status: val?.[0]?.status || 'done',
            url: this.$Dolphin.path.filePath + (val?.FILE_NAME || val?.[0]?.FILE_NAME),
          });
        }
      }
      this.fileList = fileList;
    },
    remove(file){
      let arr = [];
      this.$h5Api({
        type: '2010',
        data: [{"GUID_CODE": file.uid}],
        showMessage: false,
      }).then(data =>{
        this.fileList.forEach(item =>{
          if(item.uid != file.uid){
            arr.push(item)
          }
        })
        this.emitValue(arr);
        this.$emit('finished', {});
        this.$emit('remove');
      })
    }
  },
  watch:{
    value(val) {
      this.updateData(val);
    },
    '$i18n.locale'(){
      this.text = this.$t('uploadFiles')
    },
  },
  created(){
    this.updateData(this.value);
  }
}
</script>
